export const LANGUAGE_MAP = [
  { label: '中文', value: 'zh-CN', simple: 'zh' },
  { label: 'English', value: 'en-US', simple: 'en' },
  { label: 'Deutsch', value: 'de-DE', simple: 'de' },
  { label: 'Italiano', value: 'it-IT', simple: 'it' },
  { label: 'Nederlands', value: 'nl-NL', simple: 'nl' },
  { label: 'España', value: 'es-ES', simple: 'sp' },
  { label: 'Ελληνικά', value: 'el-GR', simple: 'el' },
  { label: '日本語', value: 'ja-JP', simple: 'ja' },
  { label: 'Français', value: 'fr-FR', simple: 'fr' },
]